import {assert} from 'assert-ts';
import type {Thesaurus} from 'services/thesaurus/types';
import {getSelectAction} from './getSelectAction';

export const addNodeIdWithDuplicatesToEditValue = (
  nodeId: string,
  existingNodeIds: string[],
  thesaurus: Thesaurus,
  duplicateIdToIds: Map<string, string[]>,
): string[] => {
  const action = getSelectAction(
    nodeId,
    existingNodeIds,
    thesaurus,
    undefined,
    duplicateIdToIds,
  );
  if (!action) {
    return existingNodeIds;
  }

  assert(
    action.type === 'select' || action.type === 'swap',
    'addNodeIdToThesaurusValue: action select or swap expected',
  );

  if (action.type === 'select') {
    // Add selected node
    return [
      ...existingNodeIds,
      nodeId,
      ...(duplicateIdToIds.get(nodeId) || []),
    ];
  } else {
    // Swap selected node with related nodes, i.e. nodes that are ancestors or children of selected node
    // including ancestors or children of duplicates of selected node

    // If a related node id was passed, we want to keep the posisiton of the elements (we pick the first one) we are swapping.
    if (action.relatedNodeIds.length > 0) {
      const currentPosition = existingNodeIds.indexOf(action.relatedNodeIds[0]);
      existingNodeIds.splice(currentPosition, 0, nodeId);

      return [
        ...existingNodeIds.filter(id => !action.relatedNodeIds.includes(id)),
        ...(duplicateIdToIds.get(nodeId) || []),
      ];
    }

    return [
      ...existingNodeIds.filter(id => !action.relatedNodeIds.includes(id)),
      nodeId,
      ...(duplicateIdToIds.get(nodeId) || []),
    ];
  }
};
